import { Flex, Switch, Text } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useBankTransactionDrawer } from '../../../../contexts'
import * as Styled from './styles'

export const MarkedAsPrivateToggle = (): ReactElement | null => {
  const { t } = useTranslation()
  const { isPrivate, setIsPrivate, canMarkAsPrivate, clearAllItems } = useBankTransactionDrawer()

  if (!canMarkAsPrivate) {
    return null
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked

    setIsPrivate(checked)

    // Any bookkeeping item selection (and its resulting difference type) is irrelevant once
    // marking private, since the private match doesn't take a difference type.
    if (checked) {
      clearAllItems()
    }
  }

  return (
    <Styled.ToggleRow>
      <Flex alignItems="center" justifyContent="space-between">
        <Text weight="medium">{t('bank_transactions.drawer.marked_as_private_label')}</Text>
        <Switch checked={isPrivate} onChange={handleChange} />
      </Flex>
    </Styled.ToggleRow>
  )
}
